// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rTPXY","largestCol":"styles_largestCol__2cJVE","smallestCol":"styles_smallestCol__2Lq1A"};